import { render, staticRenderFns } from "./MissingToken.vue?vue&type=template&id=24b89f84&scoped=true"
import script from "./MissingToken.vue?vue&type=script&lang=js"
export * from "./MissingToken.vue?vue&type=script&lang=js"
import style0 from "./MissingToken.vue?vue&type=style&index=0&id=24b89f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b89f84",
  null
  
)

export default component.exports